import { useState } from "react";
import { Link } from "react-router-dom";
import { cx } from "class-variance-authority";
import { LayoutDashboard, FileText, ClipboardList, Eye } from "lucide-react";
import SidebarChevron from "@/assets/icons/SidebarChevron";
import {
  Dropdown,
  DropdownTrigger,
  DropdownContent,
  DropdownItem,
} from "@/components/ui/dropdown";

export default function SidebarROC({ sidebarMinMax = false }) {
  const [sot, setSot] = useState(false);
  const [pr, setPr] = useState(false);

  // Helper function to handle accordion behavior - close all other groups when one is opened
  const handleGroupToggle = (groupSetter, currentValue) => {
    // Close all groups
    setSot(false);
    setPr(false);
    // Toggle the target group
    groupSetter(!currentValue);
  };

  return (
    <>
      <Link
        to={"/remote-operation-center/dashboard"}
        className={cx(
          "flex",
          "items-center",
          "gap-3",
          "px-4",
          "py-3",
          "rounded-lg",
          "text-gray-700",
          "hover:bg-blue-50",
          "hover:text-blue-700",
          "transition-all",
          "duration-200",
          "group",
          sidebarMinMax && "justify-center",
        )}
      >
        <LayoutDashboard className="w-5 h-5 text-gray-400 group-hover:text-blue-600" />
        {!sidebarMinMax && <span className="font-medium">Dashboard SLM</span>}
      </Link>
      <Link
        to={"/remote-operation-center/dashboard/first-level"}
        className={cx(
          "flex",
          "items-center",
          "gap-3",
          "px-4",
          "py-3",
          "rounded-lg",
          "text-gray-700",
          "hover:bg-blue-50",
          "hover:text-blue-700",
          "transition-all",
          "duration-200",
          "group",
          sidebarMinMax && "justify-center",
        )}
      >
        <LayoutDashboard className="w-5 h-5 text-gray-400 group-hover:text-blue-600" />
        {!sidebarMinMax && <span className="font-medium">Dashboard FLM</span>}
      </Link>
      <Link
        to={"/remote-operation-center/dashboard/cash-in-transit"}
        className={cx(
          "flex",
          "items-center",
          "gap-3",
          "px-4",
          "py-3",
          "rounded-lg",
          "text-gray-700",
          "hover:bg-blue-50",
          "hover:text-blue-700",
          "transition-all",
          "duration-200",
          "group",
          sidebarMinMax && "justify-center",
        )}
      >
        <LayoutDashboard className="w-5 h-5 text-gray-400 group-hover:text-blue-600" />
        {!sidebarMinMax && <span className="font-medium">Dashboard CIT</span>}
      </Link>
      <Link
        to={"/remote-operation-center/dashboard/comm-vendor"}
        className={cx(
          "flex",
          "items-center",
          "gap-3",
          "px-4",
          "py-3",
          "rounded-lg",
          "text-gray-700",
          "hover:bg-blue-50",
          "hover:text-blue-700",
          "transition-all",
          "duration-200",
          "group",
          sidebarMinMax && "justify-center",
        )}
      >
        <LayoutDashboard className="w-5 h-5 text-gray-400 group-hover:text-blue-600" />
        {!sidebarMinMax && <span className="font-medium">Dashboard CV</span>}
      </Link>
      {sidebarMinMax ? (
        <Dropdown>
          <DropdownTrigger>
            <button
              className={cx(
                "w-full",
                "flex",
                "items-center",
                "justify-center",
                "px-4",
                "py-3",
                "rounded-lg",
                "text-gray-700",
                "hover:bg-gray-100",
                "transition-all",
                "duration-200",
                "group",
              )}
            >
              <FileText className="w-5 h-5 text-gray-400 group-hover:text-gray-600" />
            </button>
          </DropdownTrigger>
          <DropdownContent>
            <div className="bg-white rounded-lg shadow-lg border border-gray-200 py-2 min-w-[200px] mx-2 my-1">
              <DropdownItem>
                <Link
                  to={"/remote-operation-center/sot/all"}
                  className="flex items-center gap-3 px-3 py-2 text-sm text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-md transition-all duration-200"
                >
                  <Eye className="w-4 h-4" />
                  All
                </Link>
              </DropdownItem>
            </div>
          </DropdownContent>
        </Dropdown>
      ) : (
        <>
          <button
            className={cx(
              "w-full",
              "flex",
              "items-center",
              "justify-between",
              "px-4",
              "py-3",
              "rounded-lg",
              "text-gray-700",
              "hover:bg-gray-100",
              "transition-all",
              "duration-200",
              "group",
            )}
            onClick={() => handleGroupToggle(setSot, sot)}
          >
            <div className="flex items-center gap-3">
              <FileText className="w-5 h-5 text-gray-400 group-hover:text-gray-600" />
              <span className="font-medium">Service Order</span>
            </div>
            <SidebarChevron />
          </button>
          {sot && (
            <div className={`flex flex-col px-[20px] gap-[20px]`}>
              <Link
                to={"/remote-operation-center/sot/all"}
                className={cx(
                  "flex",
                  "items-center",
                  "gap-3",
                  "px-3",
                  "py-2",
                  "text-sm",
                  "text-gray-600",
                  "hover:text-blue-600",
                  "hover:bg-blue-50",
                  "rounded-md",
                  "transition-all",
                  "duration-200",
                )}
              >
                <Eye className="w-4 h-4" />
                All
              </Link>
            </div>
          )}
        </>
      )}
      {sidebarMinMax ? (
        <Dropdown>
          <DropdownTrigger>
            <button
              className={cx(
                "w-full",
                "flex",
                "items-center",
                "justify-center",
                "px-4",
                "py-3",
                "rounded-lg",
                "text-gray-700",
                "hover:bg-gray-100",
                "transition-all",
                "duration-200",
                "group",
              )}
            >
              <ClipboardList className="w-5 h-5 text-gray-400 group-hover:text-gray-600" />
            </button>
          </DropdownTrigger>
          <DropdownContent>
            <div className="bg-white rounded-lg shadow-lg border border-gray-200 py-2 min-w-[200px] mx-2 my-1">
              <DropdownItem>
                <Link
                  to={"/remote-operation-center/pr/all"}
                  className="flex items-center gap-3 px-3 py-2 text-sm text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-md transition-all duration-200"
                >
                  <Eye className="w-4 h-4" />
                  All
                </Link>
              </DropdownItem>
            </div>
          </DropdownContent>
        </Dropdown>
      ) : (
        <>
          <button
            className={cx(
              "w-full",
              "flex",
              "items-center",
              "justify-between",
              "px-4",
              "py-3",
              "rounded-lg",
              "text-gray-700",
              "hover:bg-gray-100",
              "transition-all",
              "duration-200",
              "group",
            )}
            onClick={() => handleGroupToggle(setPr, pr)}
          >
            <div className="flex items-center gap-3">
              <ClipboardList className="w-5 h-5 text-gray-400 group-hover:text-gray-600" />
              <span className="font-medium">Part Request</span>
            </div>
            <SidebarChevron />
          </button>
          {pr && (
            <div className={`flex flex-col px-[20px] gap-[20px]`}>
              <Link
                to={"/remote-operation-center/pr/all"}
                className={cx(
                  "flex",
                  "items-center",
                  "gap-3",
                  "px-3",
                  "py-2",
                  "text-sm",
                  "text-gray-600",
                  "hover:text-blue-600",
                  "hover:bg-blue-50",
                  "rounded-md",
                  "transition-all",
                  "duration-200",
                )}
              >
                <Eye className="w-4 h-4" />
                All
              </Link>
            </div>
          )}
        </>
      )}
    </>
  );
}
